import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { SESSION_STORAGE_KEYS } from '../../../constants/sessionStorageKeys';

export const CustomerFooter = ({ termsUrlByBrand, logo }) => {
  const navigate = useNavigate();
  const onTakeATourButtonClicked = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.SHOW_ONBOARDING, 'true');
    navigate(CSPUrlsMap.dashboard.url);
  };

  return (
    <footer className="cspFooterContainer">
      <ul className="cspFooterLinks">
        <li>
          <a
            href={termsUrlByBrand ?? ''}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Terms of use"
          >
            Terms of use
          </a>
        </li>
        <li>
          <a
            href={CSPUrlsMap.contactUs.url}
            aria-label="Contact us"
          >
            Contact us
          </a>
        </li>
        <li>
          <button
            type="button"
            className="button text_only takeATourButton"
            onClick={onTakeATourButtonClicked}
          >
            Take a tour
          </button>
        </li>
      </ul>
      <img
        className="cspFooterLogo"
        src={logo.imageUrl}
        alt={logo.imageTitle || 'Company logo'}
        title={logo.imageTitleDescription || ''}
      />
    </footer>
  );
};

export default CustomerFooter;

CustomerFooter.propTypes = {
  termsUrlByBrand: PropTypes.string,
  logo: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageTitle: PropTypes.string,
    imageTitleDescription: PropTypes.string
  })
};
